<template>
  <div id="c_1Easy">
    <div id="c_easy_guest" v-if="isGuestLogin && showGuest"><span @click="$emit('send-events', {action: 'guest-complete'});">{{  $t('guest') }}</span> <i class="pi pi-times" @click="showGuest = false"></i></div>
    <div id="c_2Easy" class="chatroom" :class="{ 'status': !selected }">
      <div id="c_3Easy" ref="c3Easy" :style="backgroundStyle">
        <div ref="chatliveKit">
          <div v-for="conversation in filteredConversations" :key="conversation.id" class="c_4Easy">
            <LiveKitUI :liveKit="conversation.liveKit" :videoChat="true" :conversation_id="conversation.id"
              :style="{ display: getDisplay(conversation.id) }" :selectedTheme="selectedTheme" @resize-height="adjustHeight" :api="api"/>
          </div>
          <div v-for="conversation in filteredConversationsForAudio" :key="conversation.id" class="c_4Easy">
            <LiveKitUI :liveKit="conversation.liveKit" :videoChat="false" :conversation_id="conversation.id"
              :style="{ display: getDisplay(conversation.id) }" :selectedTheme="selectedTheme" @resize-height="adjustHeight" :api="api"/>
          </div>
        </div>

        <MessagesBox ref="m1Easy" :messages="conversations[selected].messages" :conversation_id="conversations[selected].id" 
          :chatType="conversations[selected].private" @select-mention="onSelectMention" :blocks="blocks" @selectMenu="onMenuSelect" :settings="settings" :my_profile="my_profile" :selectedTheme="selectedTheme" :user_access="conversations[selected].user_access"/>
          
        <div id="c_Easy_Typing" v-if="settings.typing">
          <span class="c_Easy_Typing_child" v-for="user in conversations[selected].typing" :key="user.user_id">
            <span class="writing-nick">{{ user.nickname }}</span>
            <span class="writing-dot"></span><span class="writing-dot"></span><span class="writing-dot"></span>
          </span>
        </div>
        
        <div v-if="conversations[selected].is_audio && (!conversations[selected].liveKit || conversations[selected].liveKit.access == 0)"  class="request-div">
          <Button v-if="!conversations[selected].liveKit" label="Join Audio Chat" icon="pi pi-microphone" class="request-microphone" @click="joinChat"></Button>
          <Button v-else label="Request Microphone Access" icon="pi pi-microphone-slash" class="request-microphone" @click="requestMicrophone"></Button>
        </div>


        <InputBox @typing="handleTyping" @send-message="handleSendMessage" @resize-height="adjustHeight"
          :chatType="conversations[selected].private" :blocks="blocks" :users="conversations[selected].users" :active_page="conversations[selected]" ref="chatInputEasy" />
      </div>
      <RightBarArea :active="conversations[selected]" @selectMenu="onMenuSelect" v-if="selected != 0 && show_users"
        :blocks="blocks" :follows="follows" />
    </div>
  </div>
</template>

<script>
import RightBarArea from './RightBarArea.vue';
import MessagesBox from './chat_parts/MessagesBox.vue';
import InputBox from './chat_parts/InputBox.vue';
import LiveKitUI from './LiveKitUI.vue';
export default {
  props: ['conversations', 'selected', 'my_profile', 'bg_image', 'isMobile', 'show_users', 'blocks', 'follows', 'selectedTheme', 'settings', 'isGuestLogin', 'api'],
  emits: ['selectMenu'],
  components: {
    RightBarArea,
    MessagesBox,
    InputBox,
    LiveKitUI
  },
  data() {
    return {
      showGuest: true
    };
  },
  computed: {
    filteredConversations() {
      return this.conversations.filter(conversation => (conversation.private && conversation.liveKit ));
    },

    filteredConversationsForAudio() {
      return this.conversations.filter(conversation => (!conversation.private && conversation.is_audio));
    },
    backgroundStyle() {
      return this.bg_image ?
        { backgroundImage: `url(${this.bg_image})`, backgroundSize: 'cover' } :
        { backgroundColor: `var(--p-neutral-200)` };
    }
  },
  methods: {
    requestMicrophone() {
      this.$socket.emit('requestMicrophone', this.conversations[this.selected].id);
    },
    showGuestAlert() {
      this.showGuest = true
    },
    childEvents() {

    },
    joinChat() {
            this.$socket.emit('joinAudioChat', this.conversations[this.selected].id);
    },
    getDisplay(conversation_id) {
      return this.conversations[this.selected].id === conversation_id ? 'block' : 'none';
    },
    handleTyping(data) {
      this.$emit('typing', data);
    },
    handleSendMessage(messageData) {
      this.$emit('send-message', messageData);
    },
    onMenuSelect(action) {
      this.$emit('selectMenu', action);
    },
    adjustHeight() {

      if (this.$refs.c3Easy == undefined || this.$refs.m1Easy == undefined || this.$refs.chatInputEasy == undefined) {
        return;
      }
      const c3EasyHeight = this.$refs.c3Easy.clientHeight;
      const inputBoxHeight = this.$refs.chatInputEasy.getHeight();
      const chatliveKit = this.$refs.chatliveKit.clientHeight;
      var calcH = c3EasyHeight - inputBoxHeight - chatliveKit 
      if (!this.conversations[this.selected].liveKit) {
        calcH = c3EasyHeight - inputBoxHeight;
      } 

      this.$refs.m1Easy.setHeight(calcH);
    },
    onSelectMention(user_id) {
      this.$emit('select-mention', user_id);
    }

  },
  mounted() {
    this.adjustHeight();
    window.addEventListener('resize', this.adjustHeight);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.adjustHeight);
  }

};
</script>


<style scoped>
#c_2Easy {
  height: 100%;
}

#c_1Easy {
  width: calc(100% - 320px);
  float: left;
  height: 100%;
}

#c_3Easy {
  border-right: 1px solid var(--p-neutral-200);
  height: 100%;
  width: calc(100% - 240px);
  float: left;
  position: relative;
}
div#c_easy_guest {
  position: absolute;
    top: 0px;
    z-index: 5;
    background: purple;
    color: white;
    padding: 5px;
    cursor: pointer;
    text-align: center;
    right: 0;
    left: 0;
}

div#c_easy_guest i {
  margin-top: 4px;
}
div#c_easy_guest span {
  width: calc(100% - 20px);
  display: inline-block;
}
.hide_users #c_3Easy {
  width: 100%;
}

.this_private_layout #c_3Easy {
  width: calc(100% - 375px);
}

div#c_Easy_Typing {
  position: absolute;
  bottom: 60px;
  width: 100%;
  padding: 0px 10px;
  font-size: 12px;
  display: flex;
  gap: 5px;
  overflow: none;
}

.c_Easy_Typing_child {
  background-color: var(--p-neutral-300);
  border-radius: 5px;
  padding: 1px 6px;
}

@-webkit-keyframes blink {
  0% {
    opacity: 0
  }

  50% {
    opacity: 1
  }

  to {
    opacity: 1
  }
}

@keyframes blink {
  0% {
    opacity: 0
  }

  50% {
    opacity: 1
  }

  to {
    opacity: 1
  }
}

.writing-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 2px;
  -webkit-animation-name: blink;
  animation-name: blink;
  -webkit-animation-duration: 1.4s;
  animation-duration: 1.4s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both
}

.writing-dot {
  background: #999;
  width: 2px;
  height: 2px;
  margin-bottom: 1px
}

.writing-dot:nth-child(2) {
  -webkit-animation-delay: .2s;
  animation-delay: .2s
}

.writing-dot:nth-child(3) {
  -webkit-animation-delay: .4s;
  animation-delay: .4s
}

@media screen and (max-width: 768px) {

    #c_1Easy {
        width: 100%;
    }
    .this_private_layout #c_3Easy {
        width: 100%;
    }

}

.request-div {
    position: absolute;
    bottom: 56px;
    display: flex;
    justify-content: end;
    width: 100%;
}

button.p-button.p-component.request-microphone {
    background: var(--p-neutral-400);
    color: var(--p-neutral-900);
    border: none;
    padding: 3px;
}

</style>